import React from 'react';
import styles from './TermsPrivacy.module.css';

/**
 * Índice lateral dos Termos: partes do documento com as suas seções.
 * A seção visível na tela fica destacada (activeId).
 */
const TermsTableOfContents = ({ toc, activeId, onNavigate }) => (
  <nav className={styles.toc} aria-label="Índice do documento">
    <span className={styles.tocLabel}>Neste documento</span>
    {toc.map((part) => (
      <div key={part.id} className={styles.tocPart}>
        <button
          type="button"
          className={`${styles.tocPartTitle} ${activeId === part.id ? styles.tocActive : ''}`}
          onClick={() => onNavigate(part.id)}
        >
          {part.title}
        </button>
        {part.sections.map((section) => (
          <button
            key={section.id}
            type="button"
            className={`${styles.tocItem} ${activeId === section.id ? styles.tocActive : ''}`}
            onClick={() => onNavigate(section.id)}
          >
            {section.title}
          </button>
        ))}
      </div>
    ))}
  </nav>
);

export default TermsTableOfContents;
